
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/baseUI/aiImageCreatorEntryPoint/aiImageCreatorEntryPoint.scss.css.virtualfile';
        module.exports = {"aiImageCreatorEntryPoint":"_aiImageCreatorEntryPoint_zfhuv_7"};